import { BookmarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import type { ResourceEntry } from '../utils/resourceIndex';
import { RESOURCE_KIND_LABEL } from '../utils/resourceIndex';
import { HUB_LINK_COUNT, HubCardFrame, HubIconSquare, HubLinkRow } from './HubCard';

/** Fourth "Start here" tile: browser-local pins, composed from HubCard's parts. */
export const PinnedCard: React.FC<{ entries: ResourceEntry[] }> = ({ entries }) => (
    <HubCardFrame
        icon={
            <HubIconSquare>
                <BookmarkIcon className="w-4 h-4" />
            </HubIconSquare>
        }
        title={<span className="text-base font-bold text-gray-800">Your pinned items</span>}
        count={entries.length > 0 ? entries.length : undefined}
    >
        {entries.length > 0 ? (
            <div className="flex flex-col gap-1.5 border-t border-gray-200 pt-3">
                {entries.slice(0, HUB_LINK_COUNT).map((entry) => (
                    <HubLinkRow
                        key={entry.key}
                        to={entry.path}
                        title={entry.title}
                        rightLabel={RESOURCE_KIND_LABEL[entry.kind]}
                        audience={entry.audience}
                    />
                ))}
                {entries.length > HUB_LINK_COUNT && (
                    <span className="px-3 py-2 text-xs text-gray-400">
                        +{entries.length - HUB_LINK_COUNT} more pinned
                    </span>
                )}
            </div>
        ) : (
            <div className="flex items-center gap-2.5 border-t border-gray-200 pt-4 mt-auto text-sm text-gray-400">
                <BookmarkIcon className="w-4 h-4 flex-shrink-0" />
                Nothing pinned yet
            </div>
        )}
    </HubCardFrame>
);

export default PinnedCard;
